// import React, { useEffect, useRef, useState } from "react";
// // import "./MultipleModelViewer.css";

// const MultipleModelViewer = ({ models, onModelsLoaded, onError }) => {
//   const viewerDiv = useRef(null);
//   const viewerRef = useRef(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [loadProgress, setLoadProgress] = useState(0);

//   // Get Forge Token (կարող եք հարմարեցնել ձեր API-ին)
//   const getForgeToken = (callback) => {
//     // Եթե ունեք accessToken prop-ից
//     if (window.accessToken) {
//       callback(window.accessToken, 3600);
//       return;
//     }

//     // Կամ fetch արեք ձեր backend-ից
//     fetch("/api/forge/oauth/public")
//       .then((res) => res.json())
//       .then((data) => {
//         callback(data.access_token, data.expires_in);
//       })
//       .catch((err) => {
//         console.error("Failed to get token:", err);
//         onError?.("Failed to authenticate with Forge");
//       });
//   };

//   const options = {
//     env: "AutodeskProduction",
//     api: "derivativeV2",
//     getAccessToken: getForgeToken,
//     extensionOptions: {},
//   };

//   const loadManifest = (documentId) => {
//     return new Promise((resolve, reject) => {
//       const onDocumentLoadSuccess = (doc) => {
//         doc.downloadAecModelData(() => resolve(doc));
//       };
//       window.Autodesk.Viewing.Document.load(
//         `urn:${documentId}`,
//         onDocumentLoadSuccess,
//         reject,
//       );
//     });
//   };

//   useEffect(() => {
//     if (!models || models.length === 0) return;

//     const initializeAndLoad = async () => {
//       if (!window.Autodesk) {
//         console.error("Autodesk Viewer not loaded");
//         onError?.("Autodesk Viewer library not loaded");
//         return;
//       }

//       setIsLoading(true);

//       window.Autodesk.Viewing.Initializer(options, async () => {
//         try {
//           const config3d = {
//             extensions: ["ModelDiff"], // Ավելացրեք ձեր էքստենշենները
//           };

//           const view = new window.Autodesk.Viewing.AggregatedView();
//           await view.init(viewerDiv.current, { viewerConfig: config3d });
//           viewerRef.current = view;

//           // Load all models
//           const tasks = models.map((model) => loadManifest(model.urn));
//           const docs = await Promise.all(tasks);

//           const bubbles = docs
//             .map((doc) => {
//               const bubbles = doc
//                 .getRoot()
//                 .search({ type: "geometry", role: "3d" });
//               return bubbles[0] || null;
//             })
//             .filter((bubble) => bubble !== null);

//           if (bubbles.length === 0) {
//             throw new Error("No viewable 3D geometry found");
//           }

//           await view.setNodes(bubbles);
//           console.log(`${bubbles.length} models loaded successfully!`);
//           setIsLoading(false);
//           onModelsLoaded?.(bubbles);
//         } catch (err) {
//           console.error("Failed to load models:", err);
//           setIsLoading(false);
//           onError?.(err.message || "Failed to load models");
//         }
//       });
//     };

//     initializeAndLoad();

//     return () => {
//       if (viewerRef.current) {
//         try {
//           viewerRef.current.finish();
//           viewerRef.current = null;
//         } catch (err) {
//           console.warn("Error cleaning up viewer:", err);
//         }
//       }
//     };
//   }, [models]); // Re-run when models change

//   return (
//     <div className="multiple-model-viewer">
//       {isLoading && (
//         <div className="viewer-loading-overlay">
//           <div className="loading-spinner"></div>
//           <p>Loading {models?.length || 0} model(s)...</p>
//           {loadProgress > 0 && (
//             <div className="loading-progress-bar">
//               <div
//                 className="loading-progress-fill"
//                 style={{ width: `${loadProgress}%` }}
//               />
//             </div>
//           )}
//         </div>
//       )}
//       <div ref={viewerDiv} className="viewer-container" id="MyViewerDiv" />
//     </div>
//   );
// };

// export default MultipleModelViewer;

// import React, { useEffect, useRef, useState } from "react";
// // import "./MultipleModelViewer.css";
// import { resolveUserUrnId } from "../../services/issuesApi";
// import { Deff } from "../viewerExtension/deff/compare.aggregated.view";
// const MultipleModelViewer = ({
//   models,
//   accessToken,
//   onModelsLoaded,
//   onError,
// }) => {
//   const viewerDiv = useRef(null);
//   const viewerRef = useRef(null);
//   const [isLoading, setIsLoading] = useState(false);

//   // Get Forge Token - օգտագործել accessToken prop-ից
//   const getForgeToken = (callback) => {
//     if (accessToken) {
//       callback(accessToken, 3600);
//     } else {
//       onError?.("No access token available");
//     }
//   };

//   const options = {
//     env: "AutodeskProduction",
//     api: "derivativeV2",
//     getAccessToken: getForgeToken,
//     extensionOptions: {},
//   };

//   const loadManifest = (documentId) => {
//     return new Promise((resolve, reject) => {
//       const onDocumentLoadSuccess = (doc) => {
//         doc.downloadAecModelData(() => resolve(doc));
//       };
//       window.Autodesk.Viewing.Document.load(
//         `urn:${documentId}`,
//         onDocumentLoadSuccess,
//         reject,
//       );
//     });
//   };

//   useEffect(() => {
//     if (!models || models.length === 0 || !accessToken) return;

//     const initializeAndLoad = async () => {
//       if (!window.Autodesk) {
//         console.error("Autodesk Viewer not loaded");
//         onError?.("Autodesk Viewer library not loaded");
//         return;
//       }

//       setIsLoading(true);

//       window.Autodesk.Viewing.Initializer(options, async () => {
//         try {
//           const config3d = {
//             extensions: ["ModelDiff"],
//           };

//           const view = new window.Autodesk.Viewing.AggregatedView();
//           await view.init(viewerDiv.current, { viewerConfig: config3d });
//           viewerRef.current = view;

//           // Load all models
//           const tasks = models.map((model) => loadManifest(model.urn));
//           const docs = await Promise.all(tasks);

//           const bubbles = docs
//             .map((doc) => {
//               const bubbles = doc
//                 .getRoot()
//                 .search({ type: "geometry", role: "3d" });
//               return bubbles[0] || null;
//             })
//             .filter((bubble) => bubble !== null);

//           if (bubbles.length === 0) {
//             throw new Error("No viewable 3D geometry found");
//           }

//           await view.setNodes(bubbles);
//           console.log(`${bubbles.length} models loaded successfully!`);
//           setIsLoading(false);
//           onModelsLoaded?.(bubbles);
//         } catch (err) {
//           console.error("Failed to load models:", err);
//           setIsLoading(false);
//           onError?.(err.message || "Failed to load models");
//         }
//       });
//     };

//     initializeAndLoad();

//     return () => {
//       if (viewerRef.current) {
//         try {
//           viewerRef.current.finish();
//           viewerRef.current = null;
//         } catch (err) {
//           console.warn("Error cleaning up viewer:", err);
//         }
//       }
//     };
//   }, [models, accessToken]); // Re-run when models or accessToken change

//   return (
//     <div className="multiple-model-viewer">
//       {isLoading && (
//         <div className="viewer-loading-overlay">
//           <div className="loading-spinner"></div>
//           <p>Loading {models?.length || 0} model(s)...</p>
//         </div>
//       )}
//       <div ref={viewerDiv} className="viewer-container" id="MyViewerDiv" />
//     </div>
//   );
// };

// export default MultipleModelViewer;

import React, { useEffect, useRef, useState } from "react";
import { Deff } from "../viewerExtension/deff/compare.aggregated.view";

const MultipleModelViewer = ({
  models,
  accessToken,
  onModelsLoaded,
  onError,
}) => {
  const viewerDiv = useRef(null);
  const viewerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const getForgeToken = (callback) => {
    if (accessToken) callback(accessToken, 3600);
    else onError?.("No access token available");
  };

  const options = {
    env: "AutodeskProduction",
    api: "derivativeV2",
    getAccessToken: getForgeToken,
    extensionOptions: {},
  };

  const loadManifest = (documentId) =>
    new Promise((resolve, reject) => {
      window.Autodesk.Viewing.Document.load(
        `urn:${documentId}`,
        (doc) => doc.downloadAecModelData(() => resolve(doc)),
        reject,
      );
    });

  useEffect(() => {
    if (!models || models.length !== 2 || !accessToken) return;

    const initializeAndLoad = async () => {
      if (!window.Autodesk) {
        onError?.("Autodesk Viewer library not loaded");
        return;
      }

      // Ռեգիստրում ենք extension-ը ՄԻՆՉԵՎ Initializer-ի կանչը
      Deff(window.Autodesk);

      setIsLoading(true);

      window.Autodesk.Viewing.Initializer(options, async () => {
        try {
          const config3d = { extensions: ["ModelDiff"] };

          const view = new window.Autodesk.Viewing.AggregatedView();
          await view.init(viewerDiv.current, { viewerConfig: config3d });
          viewerRef.current = view;

          const tasks = models.map((model) => loadManifest(model.urn));
          const docs = await Promise.all(tasks);

          const bubbles = docs
            .map(
              (doc) =>
                doc.getRoot().search({ type: "geometry", role: "3d" })[0] ||
                null,
            )
            .filter(Boolean);

          if (bubbles.length < 2) {
            throw new Error("Both models must have viewable 3D geometry");
          }

          await view.setNodes(bubbles);
          setIsLoading(false);
          onModelsLoaded?.(bubbles);

          // Ավտոմատ գործարկում compare-ը, հենց 2 մոդելը բեռնված են
          const diffExt = view.viewer?.getExtension?.("ModelDiff");
          diffExt?.modelDiff();
        } catch (err) {
          console.error("Failed to load models:", err);
          setIsLoading(false);
          onError?.(err.message || "Failed to load models");
        }
      });
    };

    initializeAndLoad();

    return () => {
      if (viewerRef.current) {
        try {
          viewerRef.current.finish();
          viewerRef.current = null;
        } catch (err) {
          console.warn("Error cleaning up viewer:", err);
        }
      }
    };
  }, [models, accessToken]);

  return (
    <div className="multiple-model-viewer">
      {isLoading && (
        <div className="viewer-loading-overlay">
          <div className="loading-spinner"></div>
          <p>Loading {models?.length || 0} model(s)...</p>
        </div>
      )}
      <div ref={viewerDiv} className="viewer-container" id="MyViewerDiv" />
    </div>
  );
};

export default MultipleModelViewer;
